var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navi"},[_c('div',{staticClass:"navi_container"},[_c('ul',{style:({ height: _vm.naviHeight})},_vm._l((_vm.navi_items),function(iterm,val){return _c('li',{class:{'selected_li':val==_vm.currentPage},attrs:{"id":val},on:{"click":function($event){return _vm.navi_go(val, $event)}}},[_c('a',[_vm._v(_vm._s(iterm))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b1a8042","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigate.vue
// module id = null
// module chunks = 